import React from 'react';
import "./footer.css";
import { FiGithub, FiLinkedin } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
        <div className="footer__container container">
            <h1 className="footer__title">Gabriel Moraes</h1>
            <ul className="footer__list">
                <li>
                    <a href="#about" className="footer__link">Sobre</a>
                </li>
                <li>
                    <a href="#portfolio" className="footer__link">Projetos</a>
                </li>
            </ul>
            <div className="footer__social">
                <a href="https://wa.me/message/5PEOPAQWQTRPF1" className="home__social-icon" target="_blank" rel="noreferrer">
                    <FaWhatsapp />
                </a>
                <a href="https://github.com/GabrielMorais2" className="home__social-icon" target="_blank" rel="noreferrer">
                    <FiGithub />
                </a>
                <a href="https://www.linkedin.com/in/gabrielmoraes12/" className="home__social-icon" target="_blank" rel="noreferrer" >
                    <FiLinkedin />
                </a>    
            </div>
            <span className="footer__copy">Copyright © 2024 Gabriel Moraes. Todos os direitos reservados.</span>
        </div>
    </footer>
  );
}

export default Footer;